import dayjs from "dayjs";

import {
  hrDevelopmentActions,
  monographActions,
  reportsActions,
  researchActions,
  researchProjectActions,
  rewardActions,
  solutionActions,
  techCompanyActions,
} from "../actions";
import { QCV2026_SCORE_DEFAULTS } from "../constants/qcv2026.config";

export const thanhTichList = [
  "formSolution",
  "formScientificResearch",
  "formScientificReport",
  "formResearchProject",
  "formMonograph",
  "formTechCompany",
  "formReward",
  "formHrDevelopment",
];

const getValue = (s) => s[0].toLowerCase() + s.slice(1);

// Lấy năm từ chuỗi ngày (hỗ trợ "DD/MM/YYYY" lẫn ISO) hoặc số năm.
const yearOf = (v) => {
  if (v == null || v === "") return NaN;
  if (typeof v === "string" && v.includes("/")) {
    return parseInt(v.split("/").slice(-1)[0], 10);
  }
  return dayjs(v).year();
};

// Từ khi form đăng ký lưu THẲNG code (qcv_score_infos) thay vì key cũ, không
// cần dict dịch nữa — ĐỒNG BỘ với DuyetThanhTichModal.js. Bản ghi cũ chưa
// migrate (còn key cũ, vd "q1") sẽ không khớp code nào -> trả undefined,
// giữ nguyên hành vi cũ (bỏ qua, không tự chấm).
const CODE_FIELD_BY_TYPE = {
  formSolution: { field: "type", muc: "1" },
  formScientificResearch: { field: "type", muc: "2" },
  formScientificReport: { field: "type", muc: "3" },
  formResearchProject: { field: "level", muc: "4" },
  formMonograph: { field: "type", muc: "5" },
  formTechCompany: { field: "applicationRange", muc: "6" },
  formReward: { field: "type", muc: "7" },
};

const getCode = (thanhTich, info, scoreInformationList) => {
  const cfg = CODE_FIELD_BY_TYPE[thanhTich];
  if (!cfg) return undefined;
  const value = info?.[cfg.field];
  if (!value) return undefined;
  const isValidCode = (scoreInformationList || []).some(
    (e) => e.code === value && String(e.code).startsWith(`${cfg.muc}.`)
  );
  return isValidCode ? value : undefined;
};

export const autoScore = (form, scoreInformationList, dispatch) => {
  // Bảng điểm cấu hình theo mùa (chỉ hạng mục QCV): ưu tiên config admin,
  // thiếu thì fallback bảng điểm mặc định QCV 2026 — ĐỒNG BỘ DuyetThanhTichModal.
  const qcvScores = (scoreInformationList || []).filter((e) => e.type === "qcv");
  const getScoreInfo = (c) => {
    const configured = qcvScores.find((e) => e?.code == c);
    if (configured && configured.value != null) return configured;
    const def = QCV2026_SCORE_DEFAULTS[c];
    return def ? { code: c, ...def } : configured;
  };

  // Cộng 10% nếu thành tích thuộc 3 năm gần đây (năm >= năm hiện tại - 2).
  const minBonusYear = dayjs().year() - 3 + 1;
  const finalValue = (sInfo, tong, year) => {
    const isRecent = !isNaN(year) && year >= minBonusYear;
    const bonusDiem = isRecent ? tong * 0.1 : 0;
    return Math.round((tong + bonusDiem) * 100) / 100;
  };

  var finalObj = {};
  thanhTichList.forEach((thanhTich) => {
    const listInfo = form?.[thanhTich] || [];

    const finalList = [];
    listInfo.forEach((infoObj) => {
      const value = getValue(thanhTich.replace("form", ""));
      const info = infoObj?.[value];
      const code = getCode(thanhTich, info, qcvScores);
      if (!code) return;

      const sInfo = getScoreInfo(code);
      const baseValue = Number(sInfo?.value) || 0;
      var scoreValue;

      if (
        thanhTich === "formScientificResearch" ||
        thanhTich === "formScientificReport" ||
        thanhTich === "formMonograph"
      ) {
        const diemChiaDeu = baseValue / 2 / (info?.numberAuthor || 1);
        const diemTgChinh =
          info?.role === "main" ? baseValue / 2 / (info?.numberMain || 1) : 0;
        const tong = diemChiaDeu + diemTgChinh;
        scoreValue = finalValue(sInfo, tong, Number(info?.publishYear));
      } else if (thanhTich === "formSolution") {
        // Sáng chế/giải pháp: tính như bài báo — chia số tác giả + số tác giả chính.
        const diemChiaDeu = baseValue / 2 / (info?.numberAuthor || 1);
        const diemTgChinh = baseValue / 2 / (info?.numberMain || 1);
        const tong = diemChiaDeu + diemTgChinh;
        scoreValue = finalValue(sInfo, tong, yearOf(info?.issueAt));
      } else if (thanhTich === "formResearchProject") {
        // Chủ trì (d1): hưởng trọn; Đồng chủ trì (d2): chia đều theo số đồng chủ trì.
        const divisor = info?.type === "d2" ? info?.numberMain || 1 : 1;
        const tong = baseValue / divisor;
        scoreValue = finalValue(sInfo, tong, yearOf(info?.start_at));
      } else if (thanhTich === "formTechCompany") {
        scoreValue = finalValue(sInfo, baseValue, Number(info?.publicYear));
      } else if (thanhTich === "formReward") {
        scoreValue = finalValue(sInfo, baseValue, yearOf(info?.decisionDay));
      } else {
        scoreValue = Math.round(baseValue * 100) / 100;
      }

      finalList.push({
        ...infoObj,
        score: scoreValue,
        accepted: false,
      });
    });
    finalObj = { ...finalObj, [thanhTich]: finalList };
  });

  dispatch(
    researchActions.updateResearchAccepted(
      finalObj.formScientificResearch,
      true
    )
  ).then(() => {
    dispatch(
      reportsActions.updateReportAccepted(finalObj.formScientificReport, true)
    ).then(() => {
      dispatch(
        solutionActions.updateSolutionAccepted(finalObj.formSolution, true)
      ).then(() => {
        dispatch(
          researchProjectActions.updateResearchProjectAccepted(
            finalObj.formResearchProject,
            true
          )
        ).then(() => {
          dispatch(
            monographActions.updateMonographAccepted(
              finalObj.formMonograph,
              true
            )
          ).then(() => {
            dispatch(
              techCompanyActions.updateTechCompanyAccepted(
                finalObj.formTechCompany,
                true
              )
            ).then(() => {
              dispatch(
                rewardActions.updateRewardAccepted(finalObj.formReward, true)
              ).then(() => {
                dispatch(
                  hrDevelopmentActions.updateHrDevelopmentAccepted(
                    finalObj.formHrDevelopment,
                    true
                  )
                );
              });
            });
          });
        });
      });
    });
  });
};
